import React, { useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import useOutsideClick from "../hooks/useOutsideClick";
import { useGetEmotionNames } from "../Controllers/DashboardController";
import { retrieve, save } from "../helpers/StorageHelper";
import useSidebarStore from "../zustand-stores/SidebarStore";

export default function JournalSidebar({ open, onLinkClick, setOpenJournalSidebar }) {
  const { sidebarCollapsed } = useSidebarStore();
  const ref = useRef(null);
  const sidebarState = sidebarCollapsed ? "collapsed" : "expanded";
  const [emotions, setEmotions] = useState(null);

  // Use the new controller hook
  const { data: emotionsData, isLoading: emotionsLoading } =
    useGetEmotionNames();

  useOutsideClick(ref, () => {
    setOpenJournalSidebar(false);
  });

  useEffect(() => {
    if (emotionsData?.emotion_names) {
      const emotionsRaw = emotionsData.emotion_names;


      const combinedEmotions = [
        ...(Array.isArray(emotionsRaw.Reframes) ? emotionsRaw.Reframes : []),
        ...(Array.isArray(emotionsRaw.Results) ? emotionsRaw.Results : []),
      ];
      save("emotions", combinedEmotions);
      setEmotions(emotionsRaw);
    }
  }, [emotionsData]);

  return (
    <div
      ref={ref}
      className={`journal-sidebar no-scrollbar ${!open && "d-none"}`}
      style={{
        left: sidebarState === "collapsed" && open ? "106px" : "300px",
      }}
    >
      <div className="d-flex flex-column gap-4">
        <div className="ms-1">
          <h1 className="text-heading-journal-sidebar mb-0">Reframes</h1>
        </div>
        <ul className="nav flex-column">
          {(emotions?.Reframes || []).map((emotion, index) => (
            <li className="nav-item" key={index}>
              <Link
                to={`/journal/${emotion.emotion_name.toLowerCase().replace(/\s+/g, "-")}`}
                className="nav-link text-body-journal-sidebar"
                onClick={onLinkClick}
              >
                {emotion.emotion_name}
              </Link>
            </li>
          ))}
        </ul>
      </div>
      <div className="d-flex flex-column gap-4" style={{ marginTop: "52px" }}>
        <div className="ms-1">
          <h1 className="text-heading-journal-sidebar mb-0">Results</h1>
        </div>
        <ul className="nav flex-column">
          {(emotions?.Results || []).map((emotion, index) => (
            <li className="nav-item" key={index}>
              <Link
                to={`/journal/${emotion.emotion_name.toLowerCase().replace(/\s+/g, "-")}`}
                className="nav-link text-body-journal-sidebar"
                onClick={onLinkClick}
              >
                {emotion.emotion_name}
              </Link>
            </li>
          ))}
        </ul>
      </div>
      <div className="ms-1" style={{ marginTop: "32px" }}>
        <button
          className="btn-3 btn-1-primary text-body-b3"
          style={{
            width: " 169px",
            whiteSpace: "nowrap",
          }}
          onClick={() => (window.location.href = "/journal-library")}
        >
          Go to journal library
        </button>
      </div>
    </div>
  );
}
